// ---------------------------------------------------------------------------
// Renderer registry — dispatches on `run.generationType`.
//
// New synth types register here; the host page (`SyntheticJobPreviewPage`)
// only ever calls `getSyntheticRenderer(generationType)` and uses what comes
// back. If no renderer is registered, a `BlobListRenderer` bound to that
// generationType is returned — same behavior as before any renderer existed.
// ---------------------------------------------------------------------------

import { createBlobListRenderer } from './BlobListRenderer/BlobListRenderer.js';
import { kgChannelsRenderer } from './KgChannelsRenderer/KgChannelsRenderer.js';
import type { SyntheticResultRenderer } from './renderer.interface.js';

const REGISTRY = new Map<string, SyntheticResultRenderer>();

export function registerSyntheticRenderer(
  renderer: SyntheticResultRenderer,
): void {
  REGISTRY.set(renderer.generationType, renderer);
}

export function getSyntheticRenderer(
  generationType: string,
): SyntheticResultRenderer {
  return REGISTRY.get(generationType) ?? createBlobListRenderer(generationType);
}

/** Exposed for tests. */
export function _clearSyntheticRendererRegistry(): void {
  REGISTRY.clear();
}

// --- Built-in registrations ---
registerSyntheticRenderer(kgChannelsRenderer);
